var app = angular.module('tf.brokerageOffer', [])

    .controller('brokerageOfferCtrl', ['$scope', '$http', '$uibModalInstance', '$uibModal', 'ivAccountOpeningService',
        function brokerageOfferController($scope, $http, $uibModalInstance, $uibModal, ivAccountOpeningService) {

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.openAccOpening = function () {
            ivAccountOpeningService.start();
            $uibModalInstance.dismiss('cancel');
        };

    }])

;


